const FETCH_SUBSTITUTIONS = 'fetch_substitutions';
const FETCH_SUBSTITUTION = 'fetch_substitution';
const DELETE_SUBSTITUTION = 'delete_substitution';
const PERSIST_SUBSTITUTION = 'persist_substitution';
const CREATE_FILES_SUBSTITUTION = 'create_files_substitution';
const DELETE_FILE_SUBSTITUTION = 'delete_file_substitution';
const FETCH_FILES_SUBSTITUTION = 'fetch_files_substitution';
export default {
    FETCH_SUBSTITUTIONS,
    FETCH_SUBSTITUTION,
    DELETE_SUBSTITUTION,
    PERSIST_SUBSTITUTION,
    FETCH_FILES_SUBSTITUTION,
    DELETE_FILE_SUBSTITUTION,
    CREATE_FILES_SUBSTITUTION,
};
